
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/io-piu",
      function () {
        return require("private-next-pages/io-piu/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/io-piu"])
      });
    }
  